import React, { useEffect, useState } from "react";
import Layout from "components/structure/Layout";
import { Box } from "@mui/material";
import ReportService from "services/ReportService";

const UserLoginReport = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchModules = async () => {
      try {
        const response = await ReportService.getReport("Other");
        const activeCropList = response?.data?.response;
        setData(activeCropList);
      } catch (error) {
        console.error("Error fetching the report:", error);
      }
    };
    fetchModules();
  }, []);

  return (
    <Layout
      title="User Login Report"
      style={{ marginBottom: "100px", marginTop: "64px" }}
    >
      <Box sx={{ mt: 2}}>
        <iframe
          title="Farmer"
          width="100%"
          height="800px"
          scrolling="no"
          frameBorder="0"
          src={`https://app.powerbi.com/reportEmbed?reportId=${data[0]?.reportType}&autoAuth=true`}
          frameborder="0"
          allowFullScreen="true"
        ></iframe>
      </Box>
    </Layout>
  );
};

export default UserLoginReport;
